import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const icon = `${process.env.PUBLIC_URL}/img/burger.svg`;

const TopbarSidebarButton = (props) => {
  const propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
  };

 
    const { changeMobileSidebarVisibility, changeSidebarVisibility ,setViewState, viewState} = props;

    return (
      <div>
        <button className="topbar__button topbar__button--desktop" type="button" onClick={() => {changeSidebarVisibility() ; setViewState(!viewState)}}>
          <img src={icon} alt="" className="topbar__button-icon" />
        </button>
        <button className="topbar__button topbar__button--mobile" type="button" onClick={() => {changeMobileSidebarVisibility();setViewState(!viewState)}}>
          <img src={icon} alt="" className="topbar__button-icon" />
        </button>
      </div>
    );
  }


export default TopbarSidebarButton;
